var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackpack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.163 19.907v29.851a2.996 2.996 0 0 1-2.997 2.996H15.388a2.997 2.997 0 0 1-2.997-2.996V19.907a8.65 8.65 0 0 1 8.653-8.654h12.47a8.653 8.653 0 0 1 8.648 8.654",
    fill: "#DEE1EC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M42.163 19.906v5.687c-2.407 2.844-6.125 4.67-10.294 4.67h-8.381c-4.67 0-8.771-2.285-11.097-5.73v-4.627a8.65 8.65 0 0 1 4.542-7.617h20.688a8.65 8.65 0 0 1 4.541 7.617",
    fill: "url(#paint0_linear_9129_110564)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37.939v8.006a3.856 3.856 0 0 1-3.86 3.858V34.08A3.86 3.86 0 0 1 46 37.94m-33.63-3.86v15.723a3.86 3.86 0 0 1-3.858-3.858v-8.203a3.86 3.86 0 0 1 3.858-3.662",
    fill: "#DEE1EC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M46 42.52a1.6 1.6 0 0 1-.502.077h-3.357v-6.665a5 5 0 0 1 3.854 1.808c.008.133.004-.057.004 4.78",
    fill: "url(#paint1_linear_9129_110564)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12.37 35.932v6.665H9.014c-.17 0-.34-.026-.501-.078v-4.78a5 5 0 0 1 3.858-1.807",
    fill: "url(#paint2_linear_9129_110564)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.145 50.132h-.329V33.751h.328a4.19 4.19 0 0 1 4.186 4.187v8.007a4.19 4.19 0 0 1-4.185 4.187m.328-15.71v15.039a3.536 3.536 0 0 0 3.201-3.516v-8.007a3.536 3.536 0 0 0-3.201-3.516m-29.775 15.71h-.329a4.19 4.19 0 0 1-4.185-4.187v-8.007a4.19 4.19 0 0 1 4.185-4.187h.329zm-.657-15.71a3.536 3.536 0 0 0-3.201 3.516v8.007a3.536 3.536 0 0 0 3.201 3.516z",
    fill: "#5E6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.147 53.128H15.368a3.33 3.33 0 0 1-3.325-3.324v-29.85a8.99 8.99 0 0 1 8.982-8.982h12.469a8.99 8.99 0 0 1 8.981 8.982v29.85a3.33 3.33 0 0 1-3.328 3.324m-18.122-41.5a8.336 8.336 0 0 0-8.326 8.326v29.85a2.67 2.67 0 0 0 2.669 2.668h23.78a2.67 2.67 0 0 0 2.668-2.668v-29.85a8.336 8.336 0 0 0-8.326-8.326z",
    fill: "#5E6175"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.145 34.08a5.01 5.01 0 0 1 5.011 5.012 1.655 1.655 0 0 1-1.654 1.654h-3.358zm-29.775 0a5.01 5.01 0 0 0-5.01 5.012 1.655 1.655 0 0 0 1.654 1.654h3.357zm18.816-6.004h-7.858A12.31 12.31 0 0 1 11.02 15.768v-.8a4.87 4.87 0 0 1 4.871-4.87h22.732a4.87 4.87 0 0 1 4.871 4.87v.8a12.31 12.31 0 0 1-12.308 12.308",
    fill: "#A9AFC4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.186 28.404h-7.858A12.65 12.65 0 0 1 10.69 15.768v-.8a5.205 5.205 0 0 1 5.2-5.198h22.732a5.205 5.205 0 0 1 5.2 5.198v.8a12.65 12.65 0 0 1-12.637 12.636M15.891 10.426a4.547 4.547 0 0 0-4.543 4.542v.8a11.993 11.993 0 0 0 11.98 11.98h7.858a11.993 11.993 0 0 0 11.98-11.98v-.8a4.55 4.55 0 0 0-4.543-4.542z",
    fill: "#5E6175"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.992 22.762h2.852v2.807h-2.852zm0 7.845h2.852V33.4h-2.852z",
    fill: "#2C9424"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.172 25.899h-3.508v-3.465h3.508zm-2.852-.657h2.195V23.09H26.32zm2.852 8.486h-3.508v-3.449h3.508zm-2.852-.656h2.195v-2.137H26.32z",
    fill: "#5E6175"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.825 30.936h-2.808a1.445 1.445 0 0 1-1.443-1.443v-2.805a1.445 1.445 0 0 1 1.443-1.443h2.808a1.445 1.445 0 0 1 1.442 1.443v2.807a1.445 1.445 0 0 1-1.442 1.44m-2.808-5.031a.786.786 0 0 0-.787.786v2.81a.79.79 0 0 0 .787.786h2.808a.79.79 0 0 0 .786-.786v-2.811a.787.787 0 0 0-.787-.787z",
    fill: "#5E6175"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.825 25.571h-2.808c-.616 0-1.115.5-1.115 1.115v2.808c0 .615.5 1.114 1.115 1.114h2.808c.615 0 1.114-.499 1.114-1.114v-2.808c0-.616-.499-1.115-1.114-1.115",
    fill: "#5E6175"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.757 42.203H17.071a.865.865 0 0 1-.864-.865v-1.485a1.89 1.89 0 0 1 1.888-1.89h18.638a1.89 1.89 0 0 1 1.89 1.89v1.49a.865.865 0 0 1-.866.86",
    fill: "#A9AFC4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.502 41.074h-3.686V33.75h.328a5.346 5.346 0 0 1 5.34 5.34 1.984 1.984 0 0 1-1.982 1.983m-3.03-.657h3.03a1.33 1.33 0 0 0 1.326-1.325 4.69 4.69 0 0 0-4.355-4.673zm-29.772.658H9.013a1.984 1.984 0 0 1-1.983-1.982 5.346 5.346 0 0 1 5.34-5.341h.328zm-.657-6.655a4.69 4.69 0 0 0-4.355 4.673 1.33 1.33 0 0 0 1.326 1.325h3.029zm25.714 8.111H17.071a1.193 1.193 0 0 1-1.192-1.192v-1.485a2.22 2.22 0 0 1 2.216-2.217h18.638a2.22 2.22 0 0 1 2.218 2.217v1.49a1.194 1.194 0 0 1-1.194 1.187m-19.662-4.238a1.56 1.56 0 0 0-1.56 1.56v1.492a.537.537 0 0 0 .536.535h20.686a.537.537 0 0 0 .537-.535v-1.491a1.56 1.56 0 0 0-1.56-1.561z",
    fill: "#5E6175"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.67 49.398H19.154a1.89 1.89 0 0 1-1.888-1.89v-5.305h20.289v5.306a1.89 1.89 0 0 1-1.885 1.889",
    fill: "#DEE1EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.56 42.202v5.307a1.89 1.89 0 0 1-1.89 1.889H19.154a1.89 1.89 0 0 1-1.888-1.889v-5.307zM25.993 10.098h-7.156L16.55 4.675h6.082a1.51 1.51 0 0 1 1.43 1.013z",
    fill: "#DEE1EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.552 4.675h-.485a1.03 1.03 0 0 0-1.028 1.028v4.395h3.799z",
    fill: "#A9AFC4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.844 10.098H36l2.282-5.423h-6.078a1.51 1.51 0 0 0-1.428 1.013z",
    fill: "#DEE1EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.493 10.426h-7.875l-2.563-6.08h6.576a1.84 1.84 0 0 1 1.733 1.222zm-7.437-.657h6.437l-1.744-3.972a1.185 1.185 0 0 0-1.118-.794h-5.588zm17.163.657h-7.875l2.13-4.858a1.84 1.84 0 0 1 1.732-1.221h6.576zm-6.872-.657h6.436l2.01-4.766h-5.588a1.185 1.185 0 0 0-1.118.794c-.014.036.132-.3-1.74 3.972",
    fill: "#5E6175"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.282 4.675h.484a1.027 1.027 0 0 1 1.027 1.028v4.395H36z",
    fill: "#A9AFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M16.552 4.675h-.485a1.03 1.03 0 0 0-1.028 1.028v4.395h3.799z",
    fill: "url(#paint3_linear_9129_110564)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M38.282 4.675h.484a1.027 1.027 0 0 1 1.027 1.028v4.395H36z",
    fill: "url(#paint4_linear_9129_110564)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.332 10.426h-4.621V5.703a1.36 1.36 0 0 1 1.356-1.356h.702zm-3.965-.657h2.976l-2.01-4.766h-.266a.7.7 0 0 0-.7.7zm24.761.657h-4.62l2.563-6.08h.702a1.357 1.357 0 0 1 1.355 1.357zm-3.631-.657h2.975V5.703a.7.7 0 0 0-.7-.7h-.27zM7.36 52.472h38.642v.656H7.359z",
    fill: "#5E6175"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M17.27 42.202h20.289v1.853h-20.29z",
    fill: "url(#paint5_linear_9129_110564)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.67 49.726H19.154a2.22 2.22 0 0 1-2.216-2.217v-5.635h20.945v5.635a2.22 2.22 0 0 1-2.213 2.217M17.598 42.53v4.979a1.56 1.56 0 0 0 1.56 1.56h16.517a1.56 1.56 0 0 0 1.56-1.56V42.53z",
    fill: "#5E6175"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m45.642 20.094-.6-.265c.08-.182.156-.38.225-.584l.622.21q-.114.337-.247.64m.547-1.731-.641-.137q.063-.303.115-.628l.648.102c-.042.227-.08.45-.127.663zm.254-1.774-.657-.053q.026-.319.04-.643l.656.028q-.017.339-.044.668zm-.612-1.761a8 8 0 0 0-.052-.628l.656-.081c.027.219.047.453.057.68zm-.253-1.656a7 7 0 0 0-.189-.597l.616-.227q.118.319.207.656zm-.622-1.547q-.15-.275-.328-.536l.547-.365q.19.284.355.585zm-.969-1.358a9 9 0 0 0-.437-.444l.444-.484q.25.232.483.487zM42.726 9.18a4 4 0 0 0-.523-.302l.268-.6q.321.153.617.354z",
    fill: "#A9AFC4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 32.692a1.3 1.3 0 0 1-.502-2.496 1.298 1.298 0 1 1 .502 2.496m0-1.94a.642.642 0 1 0 0 1.284.642.642 0 0 0 0-1.284m4.313 8.214a1.002 1.002 0 1 1 0-2.004 1.002 1.002 0 0 1 0 2.004m-.347-1a.346.346 0 1 0 .692 0 .346.346 0 0 0-.692 0M6.25 15.1h2.203v.657H6.25zm.879 3.754 1.557-1.558.464.464-1.557 1.557zm-.137-6.8.464-.464 1.558 1.557-.464.464z",
    fill: "#5E6175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9129_110564",
    x1: 27.277,
    y1: 23.421,
    x2: 27.277,
    y2: 33.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9129_110564",
    x1: 44.071,
    y1: 43.938,
    x2: 44.071,
    y2: 37.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9129_110564",
    x1: 10.441,
    y1: 43.938,
    x2: 10.441,
    y2: 37.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9129_110564",
    x1: 16.939,
    y1: 7.102,
    x2: 16.939,
    y2: 11.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9129_110564",
    x1: 37.899,
    y1: 7.102,
    x2: 37.899,
    y2: 11.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9129_110564",
    x1: 27.415,
    y1: 41.713,
    x2: 27.415,
    y2: 48.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpack);
export default __webpack_public_path__ + "static/media/backpack.33098f4f52a49497572bb38cea77ca93.svg";
export { ForwardRef as ReactComponent };